import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "static/constants";
import { fetchHL7Jobs } from "../transmission/hl7Job";

export const hl7JobsApi = createApi({
  reducerPath: "hl7JobApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["hl7Jobs"],
  endpoints: ({ query }) => ({
    getHl7Jobs: query({
      queryFn: async (query) => {
        const result = await fetchHL7Jobs(query);
        return { data: result };
      },
      providesTags: ["hl7Jobs"],
    }),
  }),
});

export const { useGetHl7JobsQuery } = hl7JobsApi;
